import type { filtersType } from '../../../components/v2/filters/interfaces'

export const getFilters = ({ currentFilters, availableFilters, isAxiomaOffice }): filtersType[] => {
  const baseFilters: filtersType[] = [
    {
      name: 'id',
      label: 'Найти обращение',
      placeholder: 'Найти обращение',
      prefix: 'ID',
      type: 'input-integer',
      value: currentFilters?.id,
      options: { width: '170px' },
    },
    { name: 'phone', label: 'Телефон клиента', type: 'phone', value: currentFilters?.phone },
  ]

  const drawerFilters: filtersType[] = []

  if (isAxiomaOffice) {
    drawerFilters.unshift({
      name: 'office',
      label: 'Офис',
      placeholder: 'Выберите офис',
      type: 'select',
      value: currentFilters?.office ? parseInt(currentFilters.office) : undefined,
      options: { enum: availableFilters?.office || [] },
    })
    drawerFilters.unshift({
      name: 'brand',
      placeholder: 'Бренд',
      type: 'select',
      value: currentFilters?.brand ? parseInt(currentFilters.brand) : undefined,
      options: { enum: availableFilters?.brand || [] },
    })
  }

  return [...baseFilters, ...drawerFilters]
}
